function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonationLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 18,
    rx: 6,
    ry: 6,
    style: {
      fill: "#6bca77",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.05,9c0,.45-.37,.81-.81,.81h-1.88v1.88c0,.45-.36,.81-.81,.81s-.81-.36-.81-.81v-1.88h-1.88c-.44,0-.81-.36-.81-.81s.37-.81,.81-.81h1.88v-1.88c0-.44,.37-.81,.81-.81s.81,.37,.81,.81v1.88h1.88c.44,0,.81,.37,.81,.81Z",
    style: {
      fill: "#fff",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.88,5.72l-2.21-1.23c-.67-.36-1.68-.36-2.34,.01l-2.21,1.22c-.71,.4-1.24,1.3-1.24,2.11v2.34c0,.81,.53,1.72,1.24,2.11l2.21,1.23c.33,.18,.75,.28,1.17,.28s.84-.1,1.18-.28l2.2-1.23c.71-.39,1.25-1.3,1.25-2.11v-2.34c0-.81-.54-1.71-1.25-2.11Zm-4.03,6.59l-2.1-1.17c-.29-.16-.57-.63-.57-.97v-2.11l2.67,1.54v2.71Zm-2.13-5.43s.02-.01,.03-.02l2.21-1.22h0c.14-.08,.34-.12,.55-.12s.4,.04,.54,.11l2.2,1.23s0,.01,.02,.01l-2.77,1.61-2.78-1.6Zm6.11,3.29c0,.34-.28,.81-.58,.97l-2.1,1.17v-2.71l2.68-1.55v2.12Z",
    style: {
      fill: "#fff"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonationLaunch);
export default __webpack_public_path__ + "static/media/donation_launch.98c009adf452c971ed50bc4e4a67ee20.svg";
export { ForwardRef as ReactComponent };